import request from 'assets/js/http';

export function tagGroupQuery(data) {
  // 标签组查询
  return request({
    url: '/strategyTag/tagGroupQuery',
    method: 'post',
    data
  });
}

export function tagQuery(data) {
  // 标签查询
  return request({
    url: '/strategyTag/tagQuery',
    method: 'post',
    data
  });
}

export function tagGroupEdit(data) {
  // 标签组编辑
  return request({
    url: '/strategyTag/tagGroupEdit',
    method: 'post',
    data
  });
}

export function tagEdit(data) {
  // 标签编辑
  return request({
    url: '/strategyTag/tagEdit',
    method: 'post',
    data
  });
}

export function relationTypeQuery(data) {
  // 关系种类查询
  return request({
    url: '/strategyTag/relationTypeList',
    method: 'post',
    data
  });
}

export function relationQuery(data) {
  // 关系查询
  return request({
    url: '/strategyTag/relationQuery',
    method: 'post',
    data
  });
}

export function relationTypeEdit(data) {
  // 关系种类编辑
  return request({
    url: '/strategyTag/relationTypeEdit',
    method: 'post',
    data
  });
}

export function relationEdit(data) {
  // 关系编辑
  return request({
    url: '/strategyTag/relationEdit',
    method: 'post',
    data
  });
}

export function strategyTagQuery(data) {
  // 项目标签查询
  return request({
    url: '/strategyTag/strategyTagQuery',
    method: 'post',
    data
  });
}

export function strategyTagEdit(data) {
  // 项目标签编辑
  return request({
    url: '/strategyTag/strategyTagEdit',
    method: 'post',
    data
  });
}

export function relationInfo(data) {
  // 项目关联关系查询
  return request({
    url: '/strategyTag/relationInfo',
    method: 'post',
    data
  });
}

export function thirdRelationInfo(data) {
  // xiniu项目关联关系查询
  return request({
    url: '/strategyTag/thirdTagRelationInfo',
    method: 'post',
    data
  });
}
